/**
 * main.js
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

import { registerPlugins } from '#plugins/index.js'

// Components
import OneFormVue from './views/oneform/oneform.vue'

// Composables
import { createApp } from 'vue'

// Styles
import 'unfonts.css'

import { store } from '#stores/oneform.js'

async function goApp() {
    const app = createApp(OneFormVue)
    registerPlugins(app)
    await store.dbinit()    
    app.mount('#app')
}

goApp()
